export default "__VITE_ASSET__8973f9ad__"